export const clearStringAddress = (address: string, toBeFiltered: string): string => {
  return address.startsWith(toBeFiltered) ? address.replace(`${toBeFiltered}, `, '') : address
}
